import React, {useEffect, useState} from 'react';

import { styled } from '@mui/material/styles';

import { Checkbox, Divider, List, ListItem, Popover } from '@mui/material';

import LessonsSearchFilters from './lessons_search_filters';


const PREFIX = 'LessonsListFilters';

const classes = {
    paper: `${PREFIX}-paper`,
    listItem: `${PREFIX}-listItem`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.paper}`]: {
        fontFamily: 'Roboto'
    },

    [`& .${classes.listItem}`]: {
        padding: '0px',
        '&:hover': {
            backgroundColor: '#ebf0f8'
        }
    }
}));

const LessonsListFilters = (props) => {
    let {showFilters,toggleShowFilters, ll_settings, updateLLViewSettings, anchorEl} = props;


    return (
        <Root>
            <Popover
                open={showFilters}
                anchorEl={anchorEl}
                onClose={() => toggleShowFilters(true)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <LessonsSearchFilters
                    lesson_search_filters={ll_settings}
                    updateLLViewSettings={updateLLViewSettings}
                />
            </Popover>
        </Root>
    );
    // }
};

export default LessonsListFilters;
